import PopNotificationWithUndo from './PopNotificationWithUndo.component';

export default PopNotificationWithUndo;
